/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_appsync_graphqlEndpoint": "https://aqlvcc3wanc5jee32ovyjdjgby.appsync-api.us-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-vavwss4m6ngnvolc52ndmptntq",
    "aws_cognito_identity_pool_id": "us-west-1:5e5c696f-7b83-4b02-a0f3-be570085f6a7",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_A6lmkdUAH",
    "aws_user_pools_web_client_id": "3sibj2tnf0gl22uks9bjconu4l",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "htramplifystackd4469e5a28964ffc8cfff659b29e070b173142-staging",
    "aws_user_files_s3_bucket_region": "us-west-1"
};


export default awsmobile;
